import React, { Component, useEffect } from 'react';
import '../styles/App.css';
import "aos/dist/aos.css";
import Aos from 'aos';
import mobile from '../assets/smartphone-notifications.png'

const Stry = () => {
    useEffect(() => {
        Aos.init({ duration: 4000 });
    }, [])
}

class Rounds extends Component {

    render() {
        return (

            <div class="buyMain">
                <div class="conT" data-aos="zoom-in" data-aos-duration="700">NFT ROUND</div>
                <p></p>
                <div class="conT2" data-aos="zoom-in" data-aos-duration="700">Bunda NFT round</div>


                <div className='boxMainT'>
                    <div>
                        <div className='box2Main' data-aos="zoom-in" data-aos-duration="700">
                            <div class="community3">
                                <div class="conT2" id="boxBg">Round 1 price</div>
                                <p class="boxAbout2Txt">None Unlock</p>
                                <p class="boxAbout2Txt">Original Design Release </p>
                                <p class="boxAbout2Txt">Max Supply 10,000</p>
                                <p class="boxAbout2Txt"><span className='priceR'>$500</span></p>

                            </div>

                            <div class="community3">
                                <div class="conT2" id="boxBg">Round 2 price</div>
                                <p class="boxAbout2Txt">None Unlock</p>
                                <p class="boxAbout2Txt">3D Graphic Design Release</p>
                                <p class="boxAbout2Txt">Max Supply 10,000</p>
                                <p class="boxAbout2Txt"><span className='priceR'>$750</span></p>

                            </div>

                        </div>

                        <div className='box2Main'>

                            <div class="community3">
                                <div class="conT2" id="boxBg">Round 3 price</div>
                                <p class="boxAbout2Txt">None Unlock</p>
                                <p class="boxAbout2Txt">2D Graphic Design Release</p>
                                <p class="boxAbout2Txt">Max Supply 10,000</p>
                                <p class="boxAbout2Txt"><span className='priceR'>$990</span></p>
                            </div>

                        </div>
                    </div>

                    <div className='learnDiv'><img data-aos="zoom-in" data-aos-duration="700" className='learn' src={mobile} /></div>
                </div>
            </div>
        )
    }
}

export default Rounds;